import { FormVmItemConfigType, FormVmValueValidatorResultType } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../../../infrastructure/utils/form-config.utils';
import { InputValidatorType, plainText, richText } from '../../../../../../../modules/validators';
import { trimSpaces, trimSpacesLeft } from '../../../../../../../modules/formatters';
import { pagePathSymbolsValidator } from '../../../../../../../modules/passport-pages/config';

export const PAGE_NAME = 'pageName';
export const DISPLAY_NAME = 'displayName';
export const PAGE_PATH = 'pagePath';
export const DESCRIPTION = 'description';
export const ENABLED = 'enabled';

const EVENT_HUB_RESERVED_PAGE_PATHS = [
    'sign-in',
    'registration'
];

export const reservedHubPagePathValidator: InputValidatorType = (val: string = ''): FormVmValueValidatorResultType => {
    const idx = EVENT_HUB_RESERVED_PAGE_PATHS.indexOf(val);
    const valid = idx === -1;
    const validationMessage = valid
        ? null
        : {
            id: 'oe.validation.error.pagePathReserved',
            defaultMessage: 'The path {pathValue} is reserved, please choose another Page Path',
            values: { pathValue: `"${EVENT_HUB_RESERVED_PAGE_PATHS[idx]}"` }
        };
    return { valid: valid, validationMessage: validationMessage };
};

export const uniquePagePathValidator = (isExistedPath: (path: string) => boolean): InputValidatorType =>
    (path: string) => {
        const existed = isExistedPath(path);
        return {
            valid: !existed,
            validationMessage: existed
                ? { id: 'oe.eventHubs.validation.pagePathNotUnique', defaultMessage: 'The path "{pagePath}" already exists.', values: { pagePath: path } }
                : null,
        };
    };

const FORM_CONFIG = {
    [PAGE_NAME]: {
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [DISPLAY_NAME]: {
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft],
    },
    [PAGE_PATH]: {
        defaultValue: '',
        validators: [plainText.required, pagePathSymbolsValidator, reservedHubPagePathValidator, plainText.maxLength.short],
        formatters: [trimSpaces],
    },
    [DESCRIPTION]: {
        defaultValue: '',
        validators: [richText.maxLength.long],
        formatters: [trimSpacesLeft],
    },
    [ENABLED]: {
        defaultValue: true,
    },
};

export const CUSTOM_PAGE_CONFIG: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
